import { useId, useState } from 'react';
import './HelpTooltip.css';

/** Copy approved in Figma (Employee Setup, Work Details acknowledgement tooltip). Shown in BOTH the employee and the admin UI. */
export const WORK_LOCATION_ACKNOWLEDGEMENT_TOOLTIP =
  'Only the employee can check this box through the welcome email link or employee invitation form. Admins cannot edit this acknowledgment.';

interface HelpTooltipProps {
  /** Accessible name of the trigger, for example "About this acknowledgement". */
  label: string;
  text: string;
}

/** A small "i" help trigger whose text opens on hover AND keyboard focus (Escape closes it), so the help is not mouse-only. */
export function HelpTooltip({ label, text }: HelpTooltipProps) {
  const id = useId();
  const [open, setOpen] = useState(false);
  return (
    <span className="help-tooltip">
      <button
        type="button"
        className="help-tooltip__trigger"
        aria-label={label}
        aria-describedby={open ? id : undefined}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') setOpen(false);
        }}
      >
        i
      </button>
      {open && (
        <span role="tooltip" id={id} className="help-tooltip__bubble">
          {text}
        </span>
      )}
    </span>
  );
}
